<div class="story-item" [ngClass]="{'story-item--list': isListView}">
  <div class="story-item__wrap">
    <div class="row align-items-center">
      <div class="col-12">
        <!-- Header section - only show if enabled -->
        <div class="story-item__header" *ngIf="showHeader">
          <gs-skeleton-loader width="120" height="20"></gs-skeleton-loader>
        </div>
      </div>
      
      <!-- Date column - only show if not list view and date is enabled -->
      <div class="col-md-1" *ngIf="showDate && !isListView">
        <div class="story-item__date">
          <div class="story-item__date-month">
            <gs-skeleton-loader width="30" height="16"></gs-skeleton-loader>
          </div>
          <div class="story-item__date-day">
            <gs-skeleton-loader width="24" height="20"></gs-skeleton-loader>
          </div>
        </div>
      </div>
      
      <!-- Media column - only show if media is enabled -->
      <div [ngClass]="mediaColumnClass" *ngIf="shouldShowMediaSection">
        <div class="story-item__thumb" *ngIf="isImageType">
          <gs-skeleton-loader [height]="imageHeight" [appearance]="'rect'"></gs-skeleton-loader>
        </div>
        <div class="story-item__video" *ngIf="isVideoType && mediaType === 'video'">
          <gs-skeleton-loader [height]="imageHeight" [appearance]="'rect'"></gs-skeleton-loader>
          <!-- Video play button overlay -->
          <div class="video-overlay">
            <gs-skeleton-loader width="50" height="50" [appearance]="'circle'"></gs-skeleton-loader>
          </div>
        </div>
      </div>
      
      <!-- Content column -->
      <div [ngClass]="contentColumnClass" class="align-self-end">
        <div class="story-item__conts">
          <!-- Title with dynamic height -->
          <div class="story-item__title">
            <gs-skeleton-loader [height]="titleHeight"></gs-skeleton-loader>
          </div>
          
          <!-- Author info - only show if enabled -->
          <div class="story-item__info" *ngIf="showAuthor">
            <div class="story-item__user px-0 col-12">
              <div class="d-flex align-items-center">
                <gs-skeleton-loader width="32" height="32" [appearance]="'circle'"></gs-skeleton-loader>
                <div class="ml-2">
                  <gs-skeleton-loader width="80" height="16"></gs-skeleton-loader>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Tags - only show if enabled -->
          <div class="story-item__tags d-lg-block" *ngIf="showTags">
            <div class="d-flex flex-wrap">
              <gs-skeleton-loader 
                *ngFor="let tag of getTagArray()" 
                [width]="40 + (tag * 10)" 
                height="20" 
                class="mr-2 mb-1">
              </gs-skeleton-loader>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Detail section - only show if description or contributors are enabled -->
  <div class="story-item__detail" *ngIf="showDescription || showContributors">
    <div class="story-item__detail-wrap">
      <!-- Description - only show if enabled and media exists -->
      <div class="story-item__detail-desc" *ngIf="showDescription && shouldShowMediaSection">
        <gs-skeleton-loader [height]="descriptionHeight"></gs-skeleton-loader>
      </div>
      
      <!-- Contributors - only show if enabled -->
      <div class="story-item__detail-player" *ngIf="showContributors">
        <div class="d-flex">
          <div class="player-item mr-2" *ngFor="let contributor of getContributorArray()">
            <div class="player-item__avatar">
              <gs-skeleton-loader width="40" height="40" [appearance]="'circle'"></gs-skeleton-loader>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Read More button -->
      <div class="story-item__detail-more">
        <gs-skeleton-loader width="100" height="36" [appearance]="'rect'"></gs-skeleton-loader>
      </div>
    </div>
  </div>
</div>
